import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'playerSeekbar',
})
export class PlayerSeekbarPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  transform(max: number, value: number): unknown {
    if (max <= 0) return '0';
    const seekValue = Math.floor((value / max) * 100);
    if (value > max) return '100';
    return seekValue.toString();
  }
}
